/**
 * Legacy-Redirect: /premium/* → /plans (Welle-2-Review F8)
 *
 * Produktive Mail-/Backend-Links zeigen auf Unterpfade der alten Tarifseite —
 * u. a. /premium/trial und /premium/select_upgrade (v1-Rails-Routen). Ohne
 * diese Splat-Route matcht nichts und die Links laufen in einen 404; der
 * Redirect auf /premium selbst greift dort NICHT.
 *
 * Bewusst als eigenstaendige Route (`premium_`, also nicht unter der
 * /premium-Route verschachtelt): so bleibt _auth.premium.tsx ein Blatt und der
 * Splat kann jeden Unterpfad einsammeln, ohne dass /premium eine Layout-Route
 * mit Index-Kind braucht.
 */
import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_auth/premium_/$')({
  beforeLoad: () => {
    throw redirect({ to: '/plans', replace: true })
  },
  component: () => null,
})
